import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('poweroceanapp');
    const { locale } = useRouter();

    return (
        <div className={`ef-app-pc-c ${css.efAppPCC}`}>
            <div className="text-wrapper">
                <p className="sub-title">{t('sec3_subtitle')}</p>
                <p className="title">{t('sec3_title')}</p>
            </div>
            <div className="panel-wrapper">
                <div className="panel panel-1">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/3-1.webp')}
                        src={require('@publicLocal/power-ocean/app/3-1.png')}
                        alt={t('sec3_title')}
                        aria-label={t('sec3_title')}
                    />
                    <p className="title">{t('sec3_panel1_title')}</p>
                    <p className="desc">{t('sec3_panel1_desc')}</p>
                </div>
                <div className="panel panel-2">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/3-2.webp')}
                        src={require('@publicLocal/power-ocean/app/3-2.png')}
                        alt={t('sec3_title')}
                        aria-label={t('sec3_title')}
                    />
                </div>
                <div className="panel panel-3">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/3-3.webp')}
                        src={require('@publicLocal/power-ocean/app/3-3.png')}
                        alt={t('sec3_title')}
                        aria-label={t('sec3_title')}
                    />
                </div>
                <div className="panel panel-4">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/3-4.webp')}
                        src={require('@publicLocal/power-ocean/app/3-4.png')}
                        alt={t('sec3_title')}
                        aria-label={t('sec3_title')}
                    />
                    <p className="title">{t('sec3_panel4_title')}</p>
                    <p className="desc">{t('sec3_panel4_desc')}</p>
                </div>
            </div>
        </div>
    );
}
